import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../ProgressBar";
import NextBackButton from "../NextBackButton";

export const LandStatus = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);

  const [isVisible, setIsVisible] = useState(true);

  const LandStatusOptions = [
    { id: "paidOff", title: "My land is paid off" },
    { id: "ownWithLoan", title: "I own land with a current loan" },
    { id: "foundLand", title: "Found land I'm ready to buy" },
    { id: "searching", title: "I'm actively searching for land" },
    { id: "needHelp", title: "Help me locate a real estate agent to find available land" },
  ];

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });
  const checkForNextStep = () => {
    if (formData.landStatus === "") {
      setError(true);
      console.log("error");
    }
    if (formData.landStatus !== "") {
      navigation.next();
      console.log("next");
    }
  };

  return (
    <div className="flex flex-col h-screen w-full">
      <ProgressBar width={"78%"} />
      <div className="flex-grow max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center">
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className="mx-auto flex flex-col justify-center items-center">
              <h1 className="pb-8 text-4xl text-blue-primary font-semibold text-center w-full">
                Do you have land?
              </h1>
              <div>
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">Do you already have land?</legend>
                  <div className="space-y-3">
                    {LandStatusOptions.map((times) => (
                      <div key={times.id} className="flex ml-10 items-center">
                        <input
                          onChange={setForm}
                          checked={formData.landStatus === times.id}
                          value={times.id}
                          id={times.id}
                          name="landStatus"
                          type="radio"
                          className="h-4 w-4 text-white border-gray-satan"
                        />
                        <label htmlFor={times.id} className="ml-3 block text-xl font-medium text-gray-satan">
                          {times.title}
                        </label>
                      </div>
                    ))}
                    {error ? <p className="text-red-error text-center">Please fill out an answer</p> : null}
                  </div>
                </fieldset>
              </div>
            </animated.div>
          ) : null
        )}
      </div>
      <NextBackButton callBack={checkForNextStep} goBack={() => navigation.previous()} />
    </div>
  );
};
